import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useQuery } from "~/Hooks/useQuery";
import { Brands } from "./Brands";
import Content from "./Content";
import { Outlet } from "./outlet";
import { FandBCategory } from "./FandBCategory";

export const FAndB = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const bannerItems = [
    {
      label: "Content",
      key: "fAndBContent",
      children: (
        <div>
          <Content />
        </div>
      ),
    },
    {
      label: "Category",
      key: "fAndBCategory",
      children: (
        <div>
          <FandBCategory />
        </div>
      ),
    },
    {
      label: "Brands",
      key: "fAndBBrands",
      children: (
        <div>
          <Brands />
        </div>
      ),
    },
    {
      label: "Outlet",
      key: "fAndBOutlet",
      children: (
        <div>
          <Outlet />
        </div>
      ),
    },
  ];

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={bannerItems}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=fAndB&subActiveTab=${activeKey || "fAndBContent"}`);
      }}
    ></Tabs>
  );
};
